import styled from 'styled-components'

export const ModalAlert = styled.div`
  .modal-alert {
    margin-top: 15px;
    font-size: 17px;
    color: ${({ theme }) => theme.cor41} !important;
  }

  .mantine-Group-root {
    justify-content: center !important;
  }
`

export const AlertPlanoContainer = styled.div`
  span {
    font-family: RobotoRegular !important;
    font-size: 16px;
  }
`
